export const ConsumerSuffix = '-Consumer';
export const FunctionPrefix = 'Func-';

export type ApiProfileType = 0 | 1 | 2;

export type ApiProfileOption = {
    key: string;
    text: string;
};

function normalizeApiSearchText(text: string | null | undefined): string {
    return (text ?? '').trim().toLowerCase();
}

export type ProfileSelectorParts = {
    api: string | null;
    farm: string | null;
    date: string | null;
    apiType: ApiProfileType;
};

export function getProfileSelectorParts(path: string | null | undefined): ProfileSelectorParts {
    const parts = path != null ? path.split('/') : [];
    const api = parts[0] ?? null;
    const farm = parts[1] ?? null;
    const date = parts[2] ?? null;

    let apiType: ApiProfileType = 0;
    if (api != null && api.endsWith(ConsumerSuffix)) {
        apiType = 1;
    } else if (api != null && api.startsWith(FunctionPrefix)) {
        apiType = 2;
    }

    return { api, farm, date, apiType };
}

export function getApiDisplayName(api: string, apiType: ApiProfileType): string {
    if (apiType === 1 && api.endsWith(ConsumerSuffix)) {
        return api.substring(0, api.length - ConsumerSuffix.length);
    }

    if (apiType === 2 && api.startsWith(FunctionPrefix)) {
        return api.substring(FunctionPrefix.length);
    }

    return api;
}

export function buildApiProfileOptions(apis: string[], apiType: ApiProfileType): ApiProfileOption[] {
    return apis
        .filter(api => {
            if (apiType === 0) {
                return !api.startsWith(FunctionPrefix) && !api.endsWith(ConsumerSuffix);
            }

            if (apiType === 1) {
                return api.endsWith(ConsumerSuffix);
            }

            return api.startsWith(FunctionPrefix);
        })
        .map(api => ({
            key: api,
            text: getApiDisplayName(api, apiType),
        }));
}

export function findApiOptionByText(text: string, options: ApiProfileOption[]): ApiProfileOption | null {
    const normalized = normalizeApiSearchText(text);
    if (!normalized) {
        return null;
    }

    return options.find(option =>
        option.text.toLowerCase() === normalized ||
        option.key.toLowerCase() === normalized,
    ) ?? null;
}

export function filterApiProfileOptions(text: string | null | undefined, options: ApiProfileOption[]): ApiProfileOption[] {
    const normalized = normalizeApiSearchText(text);
    if (!normalized) {
        return options;
    }

    return options.filter(option =>
        option.text.toLowerCase().includes(normalized) ||
        option.key.toLowerCase().includes(normalized),
    );
}
